import React from 'react';
import { Box } from '@material-ui/core';

const AutocompleteSkeleton = () => {
  return (
    <Box style={{ padding: '8px 0', maxHeight: '200px', overflow: 'hidden' }}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Box key={index} style={{ display: 'flex', alignItems: 'center', padding: '8px 16px' }}>
          <Box style={{ width: 40, height: 40, borderRadius: '50%', backgroundColor: '#E0E0E0' }} />
          <Box style={{ flex: 1, marginLeft: 16 }}>
            <Box style={{ width: '60%', height: 20, backgroundColor: '#E0E0E0', marginBottom: 8 }} />
            <Box style={{ width: '40%', height: 16, backgroundColor: '#E0E0E0' }} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default AutocompleteSkeleton;

